<div class="flex align-center justify-center logo" *ngIf="logo">
    <img [src]="logo" [alt]="alt"/>
</div>
